/**
 * 新增功能经常有头部标题, 并伴随关闭按钮的交互, 且底部有分隔线
 * 组成一个新的UI组件, 减少后续开发时间
 */
import React, {memo} from 'react';
import classNames from "classnames";
import CustomJustify from "@/pages/datalab/components/CustomJustify";
import SvgIcon from "@home/components/SvgIcon";
import LabelText from "@/pages/datalab/components/LabelText";
import './index.scss';

const Header = (props: any) => {
  const { title, operation, showCloseIcon, onClose, className, preset='262832-16-700'} = props;
  let right = operation;
  if (showCloseIcon) {
    right = (<SvgIcon
      style={{
        width: 14,
        height: 14,
      }}
      type="clonse"
      onClick={onClose}
    />);
  }
  
  return (<CustomJustify
    className={classNames("dbl-custom-header", className)}
    left={<LabelText preset={preset} lineHeight={24}>
      {title}
    </LabelText>}
    right={right}
  />);
};


export default memo(Header);